import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, XCircle, Zap, Target, TrendingUp, ShieldCheck, Clock, ChevronDown } from 'lucide-react';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59407830712401:1';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/x6ztmbQPSNTHaLz3biHQJ9/ChatGPT_Image_Apr_24__2026__10_18_23_PM-removebg-preview.png';
const tomos = [{
  title: 'FUNDAMENTOS DEL CUERPO DEL DANCER',
  subtitle: 'Por qué tu cuerpo no rinde como debería (y cómo cambiarlo)',
  chapters: [{
    title: 'El problema oculto del dancer promedio',
    items: ['Falta de preparación física real', "El mito de 'solo bailar es suficiente'", 'Estancamiento silencioso']
  }, {
    title: 'Cómo funciona el cuerpo en la danza urbana',
    items: ['Sistema muscular y control corporal', 'Coordinación vs fuerza vs resistencia', 'El rol del sistema nervioso']
  }, {
    title: 'Principios del entrenamiento aplicado a dancers',
    items: ['Sobrecarga progresiva adaptada', 'Especificidad en danza', 'Recuperación inteligente']
  }, {
    title: 'Errores que te frenan sin darte cuenta',
    items: ['Entrenar sin estructura', 'Copiar rutinas de gym', 'Sobreentrenar clases']
  }, {
    title: 'Perfil físico del dancer completo',
    items: ['Fuerza relativa', 'Control corporal', 'Movilidad útil', 'Resistencia específica']
  }]
}, {
  title: 'ENTRENAMIENTO FÍSICO PARA DANCERS',
  subtitle: 'Estructura y evaluación',
  chapters: [{
    title: 'Evaluación inicial del dancer',
    items: ['Test de fuerza relativa', 'Test de movilidad', 'Test de resistencia']
  }, {
    title: 'Entrenamiento de fuerza aplicado a danza',
    items: ['Core dinámico', 'Tren superior funcional', 'Tren inferior reactivo']
  }, {
    title: 'Control corporal',
    items: ['Ejercicios de estabilidad', 'Trabajo unilateral', 'Control en rangos extremos']
  }, {
    title: 'Movilidad activa',
    items: ['Movilidad vs flexibilidad', 'Movilidad para hips, espalda, hombros', 'Fluidez en movimiento']
  }, {
    title: 'Rutina base semanal',
    items: ['Día 1: fuerza + control', 'Día 2: movilidad + técnica', 'Día 3: resistencia + integración']
  }]
}, {
  title: 'RESISTENCIA Y ENERGÍA',
  subtitle: 'Rendimiento sin fatiga',
  chapters: [{
    title: 'Por qué te cansás rápido bailando',
    items: ['Mala base aeróbica', 'Falta de eficiencia']
  }, {
    title: 'Tipos de resistencia en danza',
    items: ['Aeróbica', 'Anaeróbica', 'Intermitente']
  }, {
    title: 'Sistemas de entrenamiento',
    items: ['Intervalos tipo battle', 'HIIT adaptado a danza', 'Cardio inteligente']
  }, {
    title: 'Rutinas específicas',
    items: ['Circuitos de rounds', 'Secuencias continuas', 'Trabajo por bloques']
  }, {
    title: 'Cómo medir progreso',
    items: ['Fatiga percibida', 'Tiempo de recuperación', 'Rendimiento en clases']
  }]
}, {
  title: 'CONTROL MOTOR Y TÉCNICA',
  subtitle: 'Precisión y limpieza',
  chapters: [{
    title: 'El problema del movimiento sin control',
    items: ["Movimientos 'sucios'", 'Falta de precisión']
  }, {
    title: 'Control motor avanzado',
    items: ['Disociación corporal', 'Timing', 'Coordinación compleja']
  }, {
    title: 'Entrenamiento de grooves',
    items: ['Flow vs rigidez', 'Musicalidad aplicada']
  }, {
    title: 'Técnica aplicada',
    items: ['Aislamientos', 'Cambios de ritmo', 'Control de pausas']
  }, {
    title: 'Rutinas de control',
    items: ['Ejercicios lentos', 'Trabajo con metrónomo', 'Secuencias progresivas']
  }]
}, {
  title: 'PLANIFICACIÓN Y PERIODIZACIÓN',
  subtitle: 'Estructura a largo plazo',
  chapters: [{
    title: 'Cómo estructurar tu semana',
    items: ['Balance baile + físico', 'Volumen e intensidad']
  }, {
    title: 'Fases de entrenamiento',
    items: ['Adaptación', 'Carga', 'Intensificación', 'Recuperación']
  }, {
    title: 'Programas según objetivo',
    items: ['Competencia', 'Mejora técnica', 'Freestyle']
  }, {
    title: 'Gestión de fatiga',
    items: ['Señales de sobreentrenamiento', 'Ajustes semanales']
  }, {
    title: 'Sistema Dancers Pro',
    items: ['Método paso a paso', 'Ejemplo real de planificación']
  }]
}, {
  title: 'MENTALIDAD Y OPTIMIZACIÓN',
  subtitle: 'El mindset del profesional',
  chapters: [{
    title: 'Mentalidad del dancer avanzado',
    items: ['Disciplina real', 'Enfoque']
  }, {
    title: 'Cómo salir del estancamiento',
    items: ['Cambios de estímulo', 'Reestructuración']
  }, {
    title: 'Prevención de lesiones',
    items: ['Zonas críticas', 'Rutinas compensatorias']
  }, {
    title: 'Optimización del rendimiento',
    items: ['Energía', 'Recuperación', 'Consistencia']
  }, {
    title: 'El sistema completo',
    items: ['Cómo integrar todo', 'Evolución a largo plazo']
  }]
}];
function TomoAccordion({
  tomo,
  index
}: {
  tomo: (typeof tomos)[0];
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-0">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full p-4 md:p-6 flex items-center gap-3 md:gap-5 text-left hover:bg-gray-50 transition-colors" data-id="element-1">
        <div className="bg-sky-500 text-white font-black text-lg md:text-xl w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-2">
          {index + 1}
        </div>
        <div className="flex-grow min-w-0" data-id="element-3">
          <p className="text-sky-600 font-bold tracking-wider uppercase text-[10px] md:text-xs mb-0.5" data-id="element-4">
            Tomo {index + 1}
          </p>
          <h3 className="text-sm md:text-xl font-black text-black leading-tight" data-id="element-5">
            {tomo.title}
          </h3>
          <p className="text-gray-500 font-medium text-xs md:text-sm mt-0.5 hidden sm:block" data-id="element-6">
            {tomo.subtitle}
          </p>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-7">
          <ChevronDown className="w-6 h-6 text-gray-400" data-id="element-8" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-9">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-10">
            <div className="px-5 md:px-6 pb-6 pt-2 border-t border-gray-100 grid md:grid-cols-2 gap-x-10 gap-y-6" data-id="element-11">
              {tomo.chapters.map((chapter, cIndex) => <div key={cIndex} data-id="element-12">
                  <h4 className="text-black font-bold text-base mb-3 flex items-start gap-2" data-id="element-13">
                    <span className="text-sky-500 font-black" data-id="element-14">
                      {cIndex + 1}.
                    </span>
                    {chapter.title}
                  </h4>
                  <ul className="space-y-2 pl-6" data-id="element-15">
                    {chapter.items.map((item, iIndex) => <li key={iIndex} className="text-gray-500 flex items-start gap-2 text-sm" data-id="element-16">
                        <span className="w-1.5 h-1.5 rounded-full bg-sky-400 flex-shrink-0 mt-1.5" data-id="element-17" />
                        {item}
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function App() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement | HTMLImageElement | HTMLButtonElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const GreenCTA = ({
    text,
    className = ''
  }: {
    text: string;
    className?: string;
  }) => <a href="#pricing" onClick={scrollToPricing} className={`inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white text-base md:text-xl font-black py-4 px-6 md:py-5 md:px-10 rounded-xl transition-all transform hover:scale-105 shadow-lg uppercase tracking-wide w-full text-center ${className}`} data-id="element-18">
      {text}
    </a>;
  return <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-sky-200" data-id="element-19">
      <SocialProof data-id="element-20" />

      {/* HERO SECTION */}
      <section className="relative pt-10 pb-8 md:pt-24 md:pb-20 overflow-hidden bg-white" data-id="element-21">
        <div className="max-w-5xl mx-auto px-4 relative z-10 text-center" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-23">
            <h1 className="text-3xl md:text-6xl lg:text-7xl font-black text-black mb-6 leading-tight text-balance" data-id="element-24">
              Deja de ir a destiempo y<br data-id="element-25" />
              <span className="text-sky-500" data-id="element-26">entrena como una profesional</span>
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mt-4 md:mt-8 relative max-w-3xl mx-auto cursor-pointer group" onClick={scrollToPricing} data-id="element-27">
            <img src={PRODUCT_IMAGE} alt="Dancers Pro System" className="w-[80%] h-auto mx-auto drop-shadow-xl hover:scale-[1.02] transition-transform duration-500" data-id="element-28" />
          </motion.div>

          <div className="mt-6 md:mt-10 text-center" data-id="element-29">
            <div className="bg-gray-50 border border-gray-200 rounded-2xl p-4 md:p-8 max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-30">
              <p className="text-lg md:text-2xl font-bold text-black" data-id="element-31">
                Si practicás danza… pero no estás mejorando, esto es para vos
              </p>
            </div>

            <GreenCTA text="👉 Quiero mejorar como dancer ahora" data-id="element-32" />
          </div>
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-12 md:py-24 bg-gray-50 border-y border-gray-200" data-id="element-33">
        <div className="max-w-4xl mx-auto px-4" data-id="element-34">
          <h2 className="text-2xl md:text-5xl font-black text-center mb-10 md:mb-16 text-black" data-id="element-35">
            Practicar más{' '}
            <span className="text-red-500" data-id="element-36">no siempre significa mejorar.</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-stretch" data-id="element-37">
            <div className="bg-white p-5 md:p-8 rounded-2xl md:rounded-3xl border border-gray-200 flex flex-col shadow-sm" data-id="element-38">
              <p className="text-xl font-bold text-black mb-5 md:mb-8" data-id="element-39">
                Podés:
              </p>
              <ul className="space-y-4 md:space-y-6 mb-6 md:mb-10 flex-grow" data-id="element-40">
                {['Repetir coreografías', 'Mirar tutoriales', 'Ir a clases'].map((item, i) => <li key={i} className="flex items-center gap-3 text-base md:text-xl text-gray-600 font-medium" data-id="element-41">
                    <XCircle className="text-red-500 w-6 h-6 md:w-8 md:h-8 flex-shrink-0" data-id="element-42" />
                    {item}
                  </li>)}
              </ul>
              <div className="bg-red-50 p-4 md:p-6 rounded-xl md:rounded-2xl border border-red-200 mt-auto" data-id="element-43">
                <p className="text-lg font-bold text-black mb-1" data-id="element-44">Y aun así…</p>
                <p className="text-xl font-black text-red-500 mb-1" data-id="element-45">
                  👉 seguir en el mismo nivel
                </p>
                <p className="text-gray-500 font-medium text-sm md:text-base" data-id="element-46">
                  Porque estás entrenando sin dirección.
                </p>
              </div>
            </div>

            <div className="bg-white p-5 md:p-8 rounded-2xl md:rounded-3xl border border-sky-200 flex flex-col shadow-sm" data-id="element-47">
              <h3 className="text-xl md:text-3xl font-black text-black mb-5 md:mb-8 flex items-center gap-2 md:gap-3" data-id="element-48">
                <span className="text-sky-500 text-3xl md:text-4xl" data-id="element-49">⚠️</span> LO
                QUE REALMENTE PASA
              </h3>
              <p className="text-base md:text-xl text-gray-600 mb-5 md:mb-8 font-medium" data-id="element-50">
                No estás estancado por falta de talento. Estás estancado porque:
              </p>
              <ul className="space-y-4 md:space-y-6 mb-6 md:mb-10 flex-grow" data-id="element-51">
                {['No sabés qué entrenar', 'No tenés estructura', 'No medís tu progreso', 'Improvisás cada sesión'].map((item, i) => <li key={i} className="flex items-center gap-3 text-base md:text-xl text-gray-600 font-medium" data-id="element-52">
                    <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-sky-500 rounded-full flex-shrink-0" data-id="element-53" />
                    {item}
                  </li>)}
              </ul>
              <div className="bg-sky-500/15 border border-sky-400/30 p-5 rounded-2xl mt-auto" data-id="element-54">
                <p className="text-lg font-black text-center text-sky-600" data-id="element-55">
                  👉 Y así es imposible evolucionar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION INTRO */}
      <section className="py-12 md:py-24 relative overflow-hidden bg-white" data-id="element-56">
        <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-57">
          <h2 className="text-3xl md:text-7xl font-black text-black mb-4 md:mb-6 tracking-tight" data-id="element-58">
            👉 <span className="text-sky-500" data-id="element-59">Dancers Pro</span>
          </h2>
          <p className="text-lg md:text-3xl text-gray-600 max-w-3xl mx-auto mb-8 md:mb-16 font-medium leading-relaxed" data-id="element-60">
            Un sistema de entrenamiento diseñado para dancers que quieren{' '}
            <span className="text-black font-bold" data-id="element-61">mejorar de verdad.</span>
          </p>

          <div className="bg-gray-50 border border-gray-200 rounded-2xl md:rounded-3xl p-5 md:p-12 shadow-sm max-w-3xl mx-auto" data-id="element-62">
            <h3 className="text-2xl md:text-3xl font-black text-black mb-3 flex items-center justify-center gap-2 md:gap-3" data-id="element-63">
              <span className="text-3xl md:text-4xl" data-id="element-64">🧠</span> ¿Qué lo hace
              diferente?
            </h3>
            <p className="text-base md:text-lg text-gray-500 mb-6 font-medium" data-id="element-65">
              No es otro curso para mirar.
            </p>

            <div className="grid grid-cols-1 gap-2.5 md:gap-3 mb-6 text-left" data-id="element-66">
              {['Rutinas estructuradas', 'Entrenamiento técnico', 'Control corporal real', 'Progresiones claras', 'Desarrollo de estilo'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-3.5 md:p-5 rounded-xl border border-gray-200" data-id="element-67">
                  <CheckCircle2 className="text-green-500 w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-68" />
                  <span className="font-bold text-black text-base md:text-lg" data-id="element-69">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* 6 TOMOS SECTION — COLLAPSIBLE */}
      <section className="py-12 md:py-24 bg-gray-50 border-y border-gray-200" data-id="element-70">
        <div className="max-w-4xl mx-auto px-4" data-id="element-71">
          <div className="text-center mb-10 md:mb-16" data-id="element-72">
            <h2 className="text-2xl md:text-6xl font-black text-black mb-3 md:mb-6" data-id="element-73">
              El Sistema <span className="text-sky-500" data-id="element-74">Completo</span>
            </h2>
            <p className="text-base md:text-xl text-gray-500 font-medium max-w-2xl mx-auto" data-id="element-75">
              Todo lo que necesitás para llevar tu danza al siguiente nivel,
              estructurado paso a paso.
            </p>
          </div>

          <div className="space-y-3 md:space-y-4" data-id="element-76">
            {tomos.map((tomo, index) => <TomoAccordion key={index} tomo={tomo} index={index} data-id="element-77" />)}
          </div>

          <div className="mt-10 md:mt-16 text-center" data-id="element-78">
            <GreenCTA text="👉 QUIERO ACCEDER AL SISTEMA COMPLETO" data-id="element-79" />
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="py-12 md:py-24 bg-white" data-id="element-80">
        <div className="max-w-5xl mx-auto px-4" data-id="element-81">
          <h2 className="text-2xl md:text-5xl font-black text-center mb-8 md:mb-16 text-black" data-id="element-82">
            Con Dancers Pro <span className="text-sky-500" data-id="element-83">vas a:</span>
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-8" data-id="element-84">
            {[{
            icon: Target,
            title: 'Saber exactamente qué entrenar'
          }, {
            icon: Zap,
            title: 'Mejorar técnica y control'
          }, {
            icon: ShieldCheck,
            title: 'Sentirte más seguro bailando'
          }, {
            icon: Clock,
            title: 'Dejar de perder tiempo'
          }, {
            icon: TrendingUp,
            title: 'Empezar a ver progreso real'
          }].map((benefit, i) => <div key={i} className={`bg-gray-50 p-5 md:p-10 rounded-2xl md:rounded-3xl border border-gray-200 text-center ${i === 4 ? 'col-span-2 md:col-span-1' : ''}`} data-id="element-85">
                <div className="bg-sky-100 w-14 h-14 md:w-20 md:h-20 rounded-xl md:rounded-2xl flex items-center justify-center mx-auto mb-4 md:mb-8" data-id="element-86">
                  <benefit.icon className="w-7 h-7 md:w-10 md:h-10 text-sky-500" data-id="element-87" />
                </div>
                <p className="text-sm md:text-xl font-bold text-black" data-id="element-88">
                  {benefit.title}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* IMAGINE SECTION */}
      <section className="py-12 md:py-24 relative bg-gray-50 border-y border-gray-200" data-id="element-89">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-90">
          <h2 className="text-2xl md:text-5xl font-black text-black mb-5 md:mb-8 flex items-center justify-center gap-2 md:gap-3" data-id="element-91">
            <span className="text-3xl md:text-5xl" data-id="element-92">🎬</span> IMAGINATE ESTO
          </h2>
          <p className="text-lg md:text-3xl text-gray-600 leading-tight mb-6 md:mb-10 font-medium" data-id="element-93">
            Entrar a entrenar y no dudar.
            <br data-id="element-94" />
            <span className="text-black font-black block mt-2 md:mt-3" data-id="element-95">
              Saber qué hacer. Sentir que avanzás. Verte mejor en cámara.
            </span>
          </p>
          <div className="inline-block bg-sky-500 text-white text-lg md:text-3xl font-black py-4 px-6 md:py-5 md:px-10 rounded-xl md:rounded-2xl transform -rotate-2 shadow-xl" data-id="element-96">
            👉 Dejar de sentirte perdido.
          </div>
        </div>
      </section>

      {/* WHO IS IT FOR — Only the ✅ section */}
      <section className="py-10 md:py-16 bg-white" data-id="element-97">
        <div className="max-w-xl mx-auto px-4" data-id="element-98">
          <div className="bg-green-50 border border-green-200 rounded-2xl p-5 md:p-10 shadow-sm" data-id="element-99">
            <h3 className="text-xl md:text-2xl font-black text-black mb-5 md:mb-8 flex items-center gap-2 md:gap-3" data-id="element-100">
              <span className="text-green-500 text-2xl md:text-3xl" data-id="element-101">✅</span>{' '}
              ESTO ES PARA VOS SI
            </h3>
            <ul className="space-y-4 md:space-y-5" data-id="element-102">
              {['Estás estancado', 'Querés mejorar en serio', 'Querés dejar de improvisar', 'Querés destacar'].map((item, i) => <li key={i} className="flex items-center gap-3 text-base md:text-lg text-gray-700 font-medium" data-id="element-103">
                  <CheckCircle2 className="text-green-500 w-6 h-6 md:w-7 md:h-7 flex-shrink-0" data-id="element-104" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      <Testimonials data-id="element-105" />

      {/* BONUSES & PRICING SECTION */}
      <section id="pricing" className="py-10 md:py-16 relative bg-white" data-id="element-106">
        <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-107">
          {/* BONUSES */}
          <div className="mb-10 md:mb-16" data-id="element-108">
            <div className="text-center mb-6 md:mb-10" data-id="element-109">
              <h2 className="text-2xl md:text-4xl font-black text-black mb-2 flex items-center justify-center gap-2 md:gap-3" data-id="element-110">
                <span className="text-3xl md:text-4xl" data-id="element-111">🎁</span> Bonos
                Exclusivos
              </h2>
              <div className="inline-block bg-sky-500 text-white font-black text-sm md:text-xl px-4 md:px-6 py-2 rounded-full uppercase tracking-wider mt-2" data-id="element-112">
                Estos bonos son gratis por el día de hoy
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6" data-id="element-113">
              {[{
              title: 'Plan de Alimentación',
              desc: 'Energía y recuperación para dancers',
              img: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80'
            }, {
              title: 'Guía de Movilidad',
              desc: 'Prevención de lesiones y flexibilidad',
              img: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80'
            }, {
              title: 'Seguimiento',
              desc: 'Plantillas para medir tu progreso',
              img: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80'
            }].map((bono, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden border border-gray-200 group shadow-sm flex sm:flex-col" data-id="element-114">
                  <div className="w-28 sm:w-full h-auto sm:h-36 overflow-hidden relative flex-shrink-0" data-id="element-115">
                    <img src={bono.img} alt={bono.title} className="w-full h-full object-cover" data-id="element-116" />
                  </div>
                  <div className="p-4 sm:p-5 sm:text-center relative flex-grow flex flex-col justify-center" data-id="element-117">
                    <div className="hidden sm:block absolute -top-5 left-1/2 -translate-x-1/2 bg-green-500 text-white font-black text-xs px-3 py-1 rounded-full z-20 shadow-lg border-2 border-white" data-id="element-118">
                      GRATIS HOY
                    </div>
                    <span className="sm:hidden inline-block bg-green-500 text-white font-black text-[10px] px-2 py-0.5 rounded-full mb-1.5 self-start" data-id="element-119">
                      GRATIS HOY
                    </span>
                    <h4 className="font-black text-black text-base md:text-lg mb-1" data-id="element-120">
                      {bono.title}
                    </h4>
                    <p className="text-gray-500 font-medium text-xs md:text-sm" data-id="element-121">
                      {bono.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* PRICING CARD */}
          <div className="max-w-2xl mx-auto bg-white border-2 border-sky-300 rounded-2xl md:rounded-3xl p-5 md:p-12 text-center shadow-lg relative overflow-hidden" data-id="element-122">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-sky-400 via-sky-500 to-sky-600" data-id="element-123" />

            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-sky-500 text-white px-4 md:px-6 py-2 rounded-full font-black text-xs md:text-base tracking-widest uppercase shadow-xl mt-3" data-id="element-124">
              Oferta Especial
            </div>

            <div className="mb-6 md:mb-10 mt-5 md:mt-6" data-id="element-125">
              <p className="text-base md:text-xl text-gray-500 mb-2 font-medium" data-id="element-126">
                Podés seguir haciendo lo mismo… Y seguir igual.
              </p>
              <p className="text-xl md:text-2xl font-black text-black mb-5 md:mb-8" data-id="element-127">
                O podés cambiar cómo entrenás…{' '}
                <span className="text-sky-500 block mt-1" data-id="element-128">
                  👉 y empezar a evolucionar.
                </span>
              </p>

              <h3 className="text-2xl md:text-4xl font-black text-black mb-2" data-id="element-129">
                Empezá hoy con Dancers Pro
              </h3>
            </div>

            <div className="flex flex-col items-center justify-center mb-6 md:mb-10 bg-gray-50 py-5 md:py-6 rounded-2xl border border-gray-200" data-id="element-130">
              <p className="text-gray-400 text-lg md:text-xl line-through mb-2 font-bold" data-id="element-131">
                Precio regular: $49.990
              </p>
              <div className="flex items-start justify-center gap-1 mb-3 md:mb-5" data-id="element-132">
                <span className="text-2xl md:text-3xl font-black text-sky-500 mt-1.5" data-id="element-133">
                  $
                </span>
                <span className="text-6xl md:text-8xl font-black text-black tracking-tighter leading-none" data-id="element-134">
                  19.990
                </span>
                <span className="text-sky-500 font-black text-base md:text-xl mt-auto mb-1.5" data-id="element-135">
                  ARS
                </span>
              </div>
              <div className="bg-green-100 border border-green-300 text-green-600 font-bold px-4 py-1 rounded-full text-sm md:text-base flex items-center gap-1.5" data-id="element-136">
                <CheckCircle2 className="w-4 h-4" data-id="element-137" />
                Pago único. Acceso de por vida.
              </div>
            </div>

            <a href={CHECKOUT_URL} className="block w-full bg-green-500 hover:bg-green-600 active:bg-green-700 text-white text-lg md:text-2xl font-black py-5 md:py-6 px-4 rounded-2xl transition-all shadow-lg mb-4 md:mb-6 uppercase tracking-wide border-b-4 border-green-700 active:border-b-0 active:translate-y-1" data-id="element-138">
              Quiero mejorar hoy
            </a>

            <p className="text-gray-500 font-bold text-base md:text-lg" data-id="element-139">
              Entrená con estructura. Mejorá con método.
            </p>

            <div className="flex items-center justify-center gap-3 mt-6 md:mt-10 pt-4 md:pt-6 border-t border-gray-200" data-id="element-140">
              <div className="flex items-center gap-2 text-gray-400 font-medium text-xs md:text-sm" data-id="element-141">
                <ShieldCheck className="w-4 h-4 md:w-5 md:h-5" data-id="element-142" />
                <span data-id="element-143">Pago 100% Seguro y Encriptado</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-6 text-center text-gray-400 text-xs border-t border-gray-200 bg-white" data-id="element-144">
        <p className="font-medium" data-id="element-145">
          © {new Date().getFullYear()} Dancers Pro. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}